import type { RefTypeLink } from '../../types/Approvals';
import type { ApprovalActionTypeMap, ApprovalStatusGroupType } from '../../types/Shared';

export const approvalStatus: ApprovalStatusGroupType = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  DELEGATED: 'Delegated',
};

export const approvalAction: ApprovalActionTypeMap = {
  APPROVED: 'Approve',
  REJECTED: 'Reject',
  DELEGATED: 'Delegate',
};

export const refTypeLinks: RefTypeLink = {
  Deliverable: '/terminal/dashboard/deliverables/refId',
  Task: '/terminal/dashboard/tasks/refId',
  Milestone: '/terminal/dashboard/milestones/refId',
  ProjectDrawInvoice: '/app/sherpa/projects/projectId/idms/drawId/invoice/refId',
  ProjectDrawDocument: '/app/sherpa/projects/projectId/idms/drawId/document/refId',
  changeOrderMilestone: '/app/sherpa/projects/projectId/change-order/milestones/refId',
  changeOrderDeliverable: '/app/sherpa/projects/projectId/change-order/deliverables/refId',
  changeOrderBudgetLineItem: '/app/sherpa/projects/projectId/change-order/budget/refId',
};
